<template>

  <select-input
    :key="rev"
    :label="label"
    v-model="formData"
    value-key="value"
    label-value="label"
    :placeholder="placeholder"
    :size="size"
    :list="selectData"
    :required="required"
    :disabled="disabled"
    :no-form="noForm"
    @change="updated"
  >
    <!-- XOL-596: forwards the trailing cue slot into the select's form item. -->
    <template #cue><slot name="cue"></slot></template>
  </select-input>

</template>

<script>

export default {
  name: 'select-approval-status',

  props: {
    label: {
      type: String,
      default: 'Approval Status'
    },
    value: {
      //      type: String,
      required: true
    },
    prop: {
      type: String,
      default () { return this.label }
    },
    size: {
      type: String,
      default: 'normal'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    helpText: {
      type: String,
      default: null
    },
    noForm: {
      type: Boolean,
      default: false
    }
  },


  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },

  watch: {
    // XOL-596: the approval is server-owned. When its save is refused or
    // another user's decision is adopted (409 stale_decision / invalid_state, a
    // re-GET), the parent changes `value` to the SERVER's, and the select must show it.
    // Both this atom and the SelectInput inside it copy the value once, in data(), and
    // never follow it, so a value that differs from what the user last picked is
    // pushed down by re-creating the inner select (the user's own pick comes back as
    // the same value and changes nothing).
    value (value) {
      if (value !== this.formData) {
        // Rebuilding the inner select drops the focus it held (a stale revert, "Use
        // their version"): put it back on the new one (XOL-596 decision fields).
        var focused = typeof document !== 'undefined' && !!this.$el && typeof this.$el.contains === 'function' && this.$el.contains(document.activeElement)

        this.formData = value
        this.rev++

        if (focused) {
          this.$nextTick(function () {
            var input = this.$el && typeof this.$el.querySelector === 'function' ? this.$el.querySelector('input') : null

            if (input && typeof input.focus === 'function') {
              input.focus()
            }
          })
        }
      }
    }
  },

  data () {
    return {
      formData: this.value,
      rev: 0,
      selectData: this.getConfig().selects.approvalStatus
    }
  }
}
</script>
